/* LUVF weekly cart - the two jobs the cart page cannot do in Liquid alone.

   1. THE CONSENT GATE. A cart holding dishes cannot check out until the
      customer ticks the box above the button.
   2. THE STALE LINE REPAIR. A dish stamped by a browser tab that sat open
      past the cutoff carries last week's date. This compares every dish
      line against dates rendered THIS request and repairs any that drifted.

   ============================================================
   WHY THE GATE IS FAIL-OPEN
   ============================================================
   sections/main-cart-footer renders the Check out button ENABLED and this
   file disables it on load. That looks backwards - a gate that depends on
   JS to close is a gate a broken script leaves open - and it is deliberate.
   Weigh the two failures: if this file 404s or throws and the button was
   rendered disabled, EVERY dish order on the site is impossible and nobody
   finds out until the day's revenue is zero. Fail-open costs a consent tick
   on a small number of sessions. One of those is recoverable, the other is not.

   The dynamic wallet buttons (Apple Pay, Google Pay, KNET express) are
   hidden rather than disabled while the box is unticked, because they
   submit straight to Shopify's checkout and would sail past the gate
   entirely. That is the hole most consent checkboxes have.

   ============================================================
   WHY THE REPAIR EXISTS, AND WHAT IT COMPARES
   ============================================================
   The dates on a line are written by a browser at add-to-cart. A phone left
   on the menu page over Saturday midnight will happily add a dish for a
   week that closed while the screen was off - the page it is reading was
   rendered hours ago. The cart page, by contrast, is fresh on every load,
   so #lvf-cycle-cart is authoritative in a way the line is not.

   IT COMPARES THE ISO VALUE, NEVER THE PROSE. "_delivery_date" is
   "2026-08-31"; "Delivery" is "Monday 31 August". Comparing prose means
   trusting a locale and a strftime format to stay identical on both sides
   forever, and the day that breaks, every single line reads as a mismatch
   and gets rewritten on every cart load. The ISO string is the comparison;
   the prose is repaired alongside it because that is what the customer reads.

   A line with the ISO missing entirely (added before this existed, or by
   something that only set "Delivery") is left alone rather than guessed at.

   This is a repair, not a guarantee. A customer who never revisits the cart
   can still check out with a stale line, which is why the Flow "LUVF Dish
   Orders - week tag" recomputes from the order's own created_at and tags
   the order. THE KITCHEN WORKS OFF THE TAG, always. This repair exists so
   the CUSTOMER is not shown a date that was already wrong.

   It runs at most once per page load, and never touches a line with no
   Delivery property - a shop item must never acquire one. */
(function(){
  if(window.__luvfWeekly) return; window.__luvfWeekly = 1;

  var REPAIRED = false;

  function node(){
    return document.getElementById('lvf-cycle-cart')
        || document.getElementById('lvf-cycle')
        || document.getElementById('lvf-cycle-global');
  }
  function attr(name){
    var n = node();
    return (n && n.getAttribute(name)) || '';
  }

  /* ---------------- 1. the consent gate ---------------- */

  function wallets(on){
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function(w){
      w.style.display = on ? '' : 'none';
    });
  }

  function gate(){
    var box = document.querySelector('[data-lvf-consent]');
    var btn = document.getElementById('checkout');
    if(!btn) return;

    /* no dishes in the cart - nothing to agree to, nothing to hide */
    if(!box){ btn.disabled = false; wallets(true); return; }

    function sync(){
      btn.disabled = !box.checked;
      wallets(box.checked);
    }
    if(!box.__wired){
      box.__wired = 1;
      box.addEventListener('change', sync);
    }
    sync();
  }

  /* ---------------- 2. the stale line repair ---------------- */

  function repair(){
    if(REPAIRED) return;
    var iso = attr('data-mine-iso');
    var day = attr('data-mine');
    if(!iso || !day) return;
    if(!document.getElementById('main-cart-items')) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(!cart || !cart.items) return;
        var bad = null;
        for(var i = 0; i < cart.items.length; i++){
          var p = cart.items[i].properties || {};
          /* only a dish line, and only one that carries the machine value.
             A shop item has neither and must never be given one. */
          if(!p.Delivery || !p._delivery_date) continue;
          if(p._delivery_date !== iso){ bad = { line: i + 1, props: p }; break; }
        }
        if(!bad) return;
        REPAIRED = true;

        var next = {};
        for(var k in bad.props){ if(Object.prototype.hasOwnProperty.call(bad.props, k)) next[k] = bad.props[k]; }
        next._delivery_date = iso;
        next.Delivery = day;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: bad.line, properties: next })
        })
        .then(function(r){ if(!r.ok) throw new Error('repair'); return r.json(); })
        .then(function(){
          /* reload so any further drifted lines get their own pass */
          REPAIRED = false;
          window.location.reload();
        });
      })
      .catch(function(){ /* a failed repair must never block the cart */ });
  }

  /* ---------------- wiring ---------------- */

  function run(){ gate(); repair(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Dawn re-renders #main-cart-footer through the Section Rendering API on
     every quantity change, which throws away the disabled attribute and the
     checkbox state together. Re-gate whenever the summary is replaced. */
  if(window.MutationObserver){
    try{
      var host = document.querySelector('.cart__footer-wrapper') || document.body;
      new MutationObserver(function(){ gate(); }).observe(host, { childList: true, subtree: true });
    }catch(e){}
  }

  document.addEventListener('luvf:cart-changed', gate);
})();